module.exports = "<img *ngIf=\"imageUrl\"  class=\"env-image canvas-img {{className}}\"  [style.width]=\"width\" [style.height]=\"height\" [style.margin-left]=\"marginLeft\" [src]=\"imageUrl\" style=\"opacity: 0\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/canvas/canvas-image.component.html
// module id = 545
// module chunks = 1